<template>
  <div v-editable="cms" :class="name">Lottie</div>
</template>

<script>
import Colors from '~/mixins/colors'
export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      name: 'a-lottie',
    }
  },
}
</script>

<style lang="scss" scoped>
.a-lottie {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
}
</style>
